import React from 'react';
import { Calendar, Camera, FileText, MapPin, Car, CheckCircle } from 'lucide-react';

const CHECKLISTE = [
  { icon: Calendar, text: 'Unfalltag / Zeitpunkt' },
  { icon: FileText, text: 'Kurzer Schadenüberblick' },
  { icon: Camera, text: 'Fotos (wenn vorhanden)' },
  { icon: Car, text: 'Fahrzeugtyp' },
  { icon: MapPin, text: 'Standort (nur allgemein)' },
  { icon: CheckCircle, text: 'Ob das Fahrzeug fahrbereit ist' }
];

export const WasBereichalten = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Vorbereitung
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Hilfreich für die erste Einschätzung
          </h2>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {CHECKLISTE.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="flex items-start gap-4 p-5 bg-gray-50 border border-gray-100 rounded-2xl">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15">
                      <Icon className="w-5 h-5 text-brand-green" />
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed text-[15px] pt-1.5">{item.text}</p>
                </div>
              );
            })}
          </div>

          <div className="bg-brand-green/5 border border-brand-green/20 rounded-2xl p-6">
            <p className="text-sm text-gray-700 leading-relaxed text-center">
              <strong>Hinweis:</strong> Wenn nicht alles vorliegt, ist das kein Problem.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};